import { getReplayInfo, getReplayPage, IReplayPageContent } from "@/services/api";
import { asyncScheduler } from "rxjs";
interface IScoreInfo {
    score: number;
    duration: number;
    date: string;
    botName: string;
    rows: IReplayPageContent[];
}
var cacheReplay:{[key:string|number]:Promise<IReplayPageContent[]>}={};
export async function getAllPages(replayId: string|number) {
    if (cacheReplay[replayId]) {
        return cacheReplay[replayId];
    }
    cacheReplay[replayId]= new Promise<IReplayPageContent[]>(resolve => {
        var allPagesPromise = Promise.resolve<IReplayPageContent[]>([]);
        asyncScheduler.schedule(async function (page: number) {
            var repayPageData = await getReplayPage(replayId, page);
            if (repayPageData && repayPageData.length) {
                allPagesPromise = allPagesPromise.then((res) => {
                    return res.concat(repayPageData.map(r=>{
                        r.data=JSON.parse(r.content);
                        r.data.RobotX=parseFloat(`${r.data.RobotX}`);
                        r.data.RobotY=parseFloat(`${r.data.RobotY}`);
                        r.data.RobotDegree=parseFloat(`${r.data.RobotDegree}`);
                        r.data.RobotTime=parseFloat(`${r.data.RobotTime}`);
                        r.data.RobotScore=parseFloat(`${r.data.RobotScore}`);

                        return r;
                    }) );
                })
                this.schedule(page + 1,10);
            } else {
                allPagesPromise.then((data) => {
                    data.sort((a, b) => {
                        var ajs = a.data;
                        var bjs = b.data;
                        if (ajs.RobotStatus.match(/Ready/i)) {
                            ajs.RobotTime = -999;
                        }
                        if (bjs.RobotStatus.match(/Ready/i)) {
                            bjs.RobotTime = -999;
                        }
                        var d=ajs.RobotTime - bjs.RobotTime;
                        if (d==0) {
                            return 0;
                        }
                        return d>0?1:-1;
                    });
                    // console.log(data.map(o=>o.data.RobotTime));
                    resolve(data);
                });
            }
        },0,1);
        
    });
    return cacheReplay[replayId];
}
export function loadReplayData2(replayId: string|number): Promise<IScoreInfo> {
    var botName: string = "";
    getReplayInfo(replayId).then(inf => {
        botName = inf[0].username;
    });
    var data = getAllPages(replayId);



    return data.then((allRows) => {
        var inf: IScoreInfo = allRows.reduce((prev: IScoreInfo, curr: IReplayPageContent) => {
            var js = JSON.parse(curr.content);
            if (js.RobotScore) {
                prev.score = parseInt(js.RobotScore);
            }
            if (js.RobotTime) {
                prev.duration = Math.max(prev.duration, parseFloat(js.RobotTime), prev.duration);
            }

            return prev;
        }, { score: 0, duration: 0, date: "", botName: "", rows: [] });
        
        inf.date = allRows.length > 0 ? allRows[allRows.length - 1].updated_at : null;
        inf.rows = allRows;
        inf.botName = botName;
        return inf;
    })
}